<template>
  <div class="help my-2">
    <h1>How can we help you?</h1> 
    <v-autocomplete
      dense
      @keyup.enter="true"
      :items="searchFaqs"
      item-text="title"
      item-value="slug"
      class="pa-5"
      v-model="searchItem"
      outlined
      label="Type your question here"
      append-icon="mdi-magnify"
      hide-details
      clearable
    ></v-autocomplete>
          <v-row class="mx-2">
          <v-col cols="12" md="3" v-for="helpGroup in helpGroups" :key="helpGroup.id">
       
       <v-card
       outlined
       :to="{ name: 'HelpSubGroup', params: {group_id: helpGroup.id} }"
  >
    <v-row align="center">
      <v-col cols="4" >
        
        <v-img
          :src="helpGroup.logo"
          >
          </v-img>
      </v-col>
      <v-col cols="8">
       
        <h4 class="text-left">{{ helpGroup.title }}</h4>

      </v-col>
    </v-row>
  
      </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
export default {
  name: "Helpcenter",
  data: () => ({
    helpGroups : [],
    searchFaqs: [],
    searchItem: null
  }),
  computed: {
    ...mapGetters(["currentUser", "isLoading", "accessToken"]),
    essentials() {
      return {
        setLoading: this.setLoading,
        accessToken: this.accessToken,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    // queries all particulars from the database
    async getAllHelpGroups() {
      var response;
      var url = endpoints.helpGroups;
      response = await api.call(this.essentials, url)
      if (response) {
        this.helpGroups = response;
      }
    },

    async getAllSearchFAQs(){
      this.searchFaqs = await api.call(this.essentials, endpoints.helpFAQs)
    },
    // handles api errors
    async handleApiErrors(err) {
      console.log(err);
      this.setLoading(false);
    },
  },
  watch: {
    searchItem(){
      this.$router.push({ name: 'HelpDescription', params: { slug: this.searchItem } })
    }
  },
  created() {
    this.getAllHelpGroups();
    this.getAllSearchFAQs();
    
  },
};
</script>